import { ERoutePaths } from 'libraries/router/types'

export const filterTypes = [
  {
    id: 0,
    text: 'Новинки',
    order: 'latest',
    filter: 'latest',
    link: null,
  },
  {
    id: 1,
    text: 'Бестселлери',
    order: 'bestseller',
    filter: 'bestseller',
    link: null,
  },
  {
    id: 2,
    text: 'Акції',
    order: '',
    filter: 'special',
    link: null,
  },
  {
    id: 3,
    text: 'Про нас',
    order: '',
    filter: '',
    link: ERoutePaths.Agreement,
  },
]

export const navigationList = [
  ...filterTypes,
]
